export default class PKW {

    kilometersatz = 0.3;

    constructor(
        active = false,
        calculated = true,
        begruendung = '',
        kilometer = 0,
        summe = 0,
        kennzeichen = ''
    ) {
        this.active = active;
        this.calculated = calculated;
        this.begruendung = begruendung;
        this.kilometer = parseFloat(kilometer).toFixed(2) || 0;
        this.summe = this.calculateSumme();
        this.kennzeichen = kennzeichen;
    }

    calculateSumme() {
        if (!this.active) {
            return 0;
        }
        if (isNaN(this.kilometer) || this.kilometer <= 0) {
            return 0;
        }
        this.summe = (parseFloat(this.kilometer) * parseFloat(this.kilometersatz)).toFixed(2);
        console.log('PKW Summe:', this.summe);
        return parseFloat(this.summe);
    }

    getSumme() {
        if(!this.summe || isNaN(this.summe)) {
            return '0.00';
        }
        return parseFloat(this.summe).toFixed(2);
    }

    toFirestore() {
        return {
            active: this.active || false,
            calculated: this.calculated,
            begruendung: this.begruendung || '',
            kilometer: parseFloat(this.kilometer).toFixed(2) || 0,
            summe: this.getSumme(),
            kennzeichen: this.kennzeichen || ''
        };
    }
}